module.exports = __webpack_public_path__ + "static/img/iconCandidate.0bbb780.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iconCandidate.png
// module id = Tfq5
// module chunks = 1